import { TRIGGER_LOG_EVENT } from '../../../controller/actions/action-types';
import { logTriggerEvent } from '../../../../lib/logger';
import {
	getLoggerAPIBaseUrl,
	isLoggerEnabled,
} from '../../../lib/general-utils';

export function eventLoggerMiddleware() {
	return next => action => {
		const { type } = action;

		if (isLoggerEnabled && type === TRIGGER_LOG_EVENT) {
			const { eventData } = action;

			logTriggerEvent(eventData, { baseUrl: getLoggerAPIBaseUrl() });
		}

		return next(action);
	};
}
